<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>代采订单列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="space-around"
    >
      <el-col
        v-for="item in resData.status"
        :key="item.key"
        :span="24 / resData.status.length"
        class="column"
      >
        <div
          class="status"
          :class="{ active: status === item.key }"
          @click="selectStatus(item.key)"
        >
          {{ item.label }}({{ item.count }})
        </div>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.woid"
                    placeholder="代采单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.market_name"
                    placeholder="市场"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.city" multiple placeholder="城市">
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pgid"
                    placeholder="选择代采组"
                    multiple
                    filterable
                  >
                    <el-option
                      v-for="item in optionsMap.optionsPg"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.order_owner"
                    filterable
                    multiple
                    placeholder="订单负责人"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in optionsMap.owner_option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.status" placeholder="选择代采单状态">
                    <el-option
                      v-for="item in optionsMap.optionsStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.cg_type" placeholder="代采单类型">
                    <el-option value="-1" label="全部"></el-option>
                    <el-option
                      v-for="item in optionsMap.optionsCgType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.pay_tool" placeholder="支付方式">
                    <el-option value="" label="全部"></el-option>
                    <el-option
                      v-for="item in optionsMap.optionsPayTools"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.order_type"
                    placeholder="代采开单方式"
                  >
                    <el-option value="" label="全部"></el-option>
                    <el-option
                      v-for="item in optionsMap.optionsOrderType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_dispense"
                    placeholder="含小店分发"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="提交时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="支付时间：">
                  <el-date-picker
                    v-model="form.pay_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.source"
                    placeholder="代采单来源"
                    multiple
                  >
                    <el-option
                      v-for="item in optionsMap.optionsSource"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="resData" :span="24" class="data-statics">
        数据汇总&nbsp;&nbsp;&nbsp;&nbsp;
        <span
          v-if="
            status === -1 ||
            status === 3 ||
            status === 4 ||
            status === 5 ||
            status === 10
          "
          >代采金额总计：¥{{
            resData.dataStatis.planPrice
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span v-if="status === -1 || status === 0"
          >财务待审核金额总计：¥{{
            resData.dataStatis.cWwaitCheckPrice
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span v-if="status === -1 || status === 1"
          >财务待付款金额总计：¥{{
            resData.dataStatis.waitPayPrice
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span v-if="status === -1 || status === 2"
          >财务已付款金额总计：¥{{
            resData.dataStatis.payPrice
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span v-if="status === -1 || status === 9"
          >价格待核实金额总计：¥{{
            resData.dataStatis.cgWaitCheckPrice
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div class="header">
          <div>数据列表：</div>
          <div class="btn-wrap">
            <!-- 隐藏掉, -- 2020.11.18 -->
            <!-- <el-buttontype="primary" size="mini"
                               @click="addnew">+创建代采订单
                    </el-button> -->
            <el-button
              class="button"
              type="default"
              size="mini"
              @click="handleCutPayMode"
              >切换代采单支付方式</el-button
            >
            <el-button
              class="button"
              style="margin-left: auto; background-color: coral"
              type="primary"
              size="mini"
              @click="payVisible = true"
              >订单付款</el-button
            >
            <el-button
              class="button"
              type="success"
              size="mini"
              @click="output"
            >
              导出</el-button
            >
          </div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
              :selectable="checkboxInit"
            >
            </el-table-column>
            <el-table-column align="center" prop="woid" label="代采订单">
            </el-table-column>
            <el-table-column align="center" label="代采类型" width="100">
              <template #default="scope">
                <p>{{ scope.row.cg_type_label }}</p>
                <p style="color: #2d59ec; font-size: 14px; line-height: 0">
                  {{ scope.row.is_dispense_label }}
                </p>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="source_text" label="代采来源">
            </el-table-column>
            <el-table-column
              align="center"
              prop="wcg_order_pay_tool"
              label="支付方式"
            >
            </el-table-column>
            <el-table-column align="center" prop="market_nikename" label="市场">
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="supply_city" label="城市"></el-table-column>
            <el-table-column
              prop="create_price"
              label="代采金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="init_num"
              label="原代采件数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="reset_on_singular"
              label="重置回待开单件数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="sum_num"
              label="代采数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="sir_num"
              label="大货入库件数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dk_amount"
              label="前置金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="activity_price"
              label="活动服务费"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop=""
              label="佣金"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                {{ scope.row.service_fee }}({{ scope.row.service_fee_rate }})
              </template>
            </el-table-column>
            <el-table-column
              prop="dispense_commission_amount"
              label="小店佣金"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop=""
              label="退货服务费"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                {{ scope.row.refund_service_fee }}({{
                  scope.row.refund_service_fee_rate
                }})
              </template>
            </el-table-column>
            <el-table-column
              prop="true_price"
              label="实付金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ded_activity_fee"
              label="活动费用抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="return_profit_fee"
              label="让利佣金抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ded_price"
              label="商品抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="pay_price"
              label="实际结算金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status_label"
              label="代采单状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="owner_admin_name"
              label="订单负责人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="提交时间"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pay_time"
              label="支付时间"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="order_type"
              label="代采开单方式"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              fixed="right"
            >
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper,sizes "
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="payVisible">
      <pay-tem
        :ids="multipleSelection"
        :url="url2"
        :pay_num="pay_num"
        :pay_money="pay_money"
        @onCloseDialog="onCloseDialog"
      ></pay-tem>
    </div>
    <CutPayModeDialog ref="CutPayModeRef" />
  </div>
</template>

<script>
import PayTem from "./wcgorder/components/PayOrderTem.vue";
import { CITY } from "@/const/CommonConst.js";
import apiBaseURL from "@/utils/baseUrl.js";
import CutPayModeDialog from "./CutPayModeDialog.vue";
import { postOptionsForWcgOrderList } from "@/openapi/erp/wcgOrder.js";

export default {
  components: {
    PayTem,
    CutPayModeDialog,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$route.query.woid) {
        vm.$set(vm.form, "woid", vm.$route.query.woid);
        vm.$set(vm.form, "create_time", []);
      }
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      optionsMap: {},
      form: {
        pagesize: 100,
        status: "",
        cg_type: "-1",
        create_time: this.defaultDate(),
        city: [],
        woid: "",
        order_type: "",
        order_owner: [],
        is_dispense: "",
        source: [1, 2, 3, 4, 5],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WcgOrder/list",
      url2: "/erp/WcgOrder/payOrder",
      status: -1,
      curPage: 1,
      sources: [
        {
          key: 1,
          label: "一手",
        },
        {
          key: 2,
          label: "爆版APP",
        },
        {
          key: 3,
          label: "商陆花",
        },
        {
          key: 4,
          label: "聚水潭",
        },
      ],
      citys: CITY,
      filterFold: false,
      pay_num: 0,
      pay_money: 0.0,
      payVisible: false,
      multipleSelection: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.getSelectionOptions();
  },
  methods: {
    onCloseDialog(e) {
      this.payVisible = false;
      this.fetchData();
    },
    checkboxInit(row, index) {
      if (row.status != 1) return 0;
      // 不可勾选
      return 1; // 可勾选
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    addnew() {
      this.$router.push(`/home/purchasing/orderedit/0`);
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.pay_num = 0;
      this.pay_money = 0.0;
      const multipleSelection = [];
      for (const key in val) {
        this.pay_num += 1;
        this.pay_money += parseFloat(val[key].pay_price);
        multipleSelection[key] = val[key].woid;
      }
      this.multipleSelection = multipleSelection;
    },
    onSubmit() {},
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },
    handleClick(row) {
      this.$router.push(`/home/purchaseorderdetail/${row.woid}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.loading = true;
      this.form.status = this.status = key;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    // 显示代采单支付方式弹框
    handleCutPayMode() {
      this.$refs.CutPayModeRef.showDialogModal();
    },
    // 获取筛选项
    getSelectionOptions() {
      postOptionsForWcgOrderList()
        .then((res) => {
          this.optionsMap = res;
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.header {
  background: #f3f3f3;
  height: 50px;
  line-height: 30px;
  padding: 0 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btn-wrap {
  position: relative;
}
.button {
  margin: 0px 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseOrderList.vue